import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function ProjectAction() {
  const [ref, vis] = useScrollReveal();

  return (
    <section data-testid="project-section" className="relative py-20 sm:py-28 overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #1A8C7A 0%, #0f6b5c 50%, #0a4f44 100%)' }}
    >
      {/* Decorative elements */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-white/5" />
        <div className="absolute -bottom-20 -left-20 w-60 h-60 rounded-full bg-[#E8621A]/10" />
      </div>

      {/* Top wave */}
      <div className="absolute top-0 left-0 w-full rotate-180">
        <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" preserveAspectRatio="none">
          <path d="M0,40 C360,80 720,0 1080,40 C1260,60 1380,50 1440,40 L1440,80 L0,80 Z" fill="#ffffff" />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className={`text-center mb-14 transition-all duration-800 ${vis ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="inline-block px-4 py-1.5 bg-white/10 text-[#E8621A] text-xs font-bold tracking-wider uppercase rounded-full mb-4">
            Projeto Social
          </span>
          <h2
            data-testid="project-title"
            className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white mb-4"
            style={{ letterSpacing: '-0.02em' }}
          >
            PROJETO AÇÃO AMIGO PESCADOR
          </h2>
          <div className="w-20 h-1 bg-[#E8621A] mx-auto rounded-full" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text */}
          <div>
            <p className="text-base sm:text-lg text-white/90 leading-relaxed mb-6">
              Levamos ações de saúde e cidadania para os ribeirinhos das áreas mais remotas nos Estados
              do Pará e Amapá, com isso diminuímos a desigualdade e o distanciamento social que existe
              na Amazônia.
            </p>
            <p className="text-base sm:text-lg text-white/90 leading-relaxed mb-8">
              O projeto Ação Amigo Pescador surgiu da necessidade de combater a desigualdade que temos
              entre os grandes centros e a nossa população ribeirinha.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-3 bg-white/10 rounded-xl px-5 py-3 backdrop-blur-sm">
                <i className="fas fa-stethoscope text-[#E8621A] text-lg"></i>
                <span className="text-white text-sm font-medium">Saúde</span>
              </div>
              <div className="flex items-center gap-3 bg-white/10 rounded-xl px-5 py-3 backdrop-blur-sm">
                <i className="fas fa-id-card text-[#E8621A] text-lg"></i>
                <span className="text-white text-sm font-medium">Cidadania</span>
              </div>
              <div className="flex items-center gap-3 bg-white/10 rounded-xl px-5 py-3 backdrop-blur-sm">
                <i className="fas fa-hands-helping text-[#E8621A] text-lg"></i>
                <span className="text-white text-sm font-medium">Igualdade</span>
              </div>
            </div>
          </div>

          {/* Video */}
          <div className="video-container">
            <video
              data-testid="project-video"
              controls
              preload="metadata"
              poster="/images/sections/624db40cb5a0207821a228cff1e4a746.jpg"
              className="w-full rounded-2xl"
            >
              <source src="/videos/video-2.mp4" type="video/mp4" />
              Seu navegador não suporta vídeos.
            </video>
          </div>
        </div>

        {/* Section images */}
        <div className="mt-14 grid grid-cols-3 gap-4">
          <div className="rounded-xl overflow-hidden">
            <img src="/images/sections/624db40cb5a0207821a228cff1e4a746.jpg" alt="Ação amigo pescador" className="w-full h-40 sm:h-56 object-cover hover:scale-105 transition-transform duration-500" />
          </div>
          <div className="rounded-xl overflow-hidden">
            <img src="/images/sections/e09eea9956a3763ffb004c6ad092866d.jpg" alt="Ação amigo pescador" className="w-full h-40 sm:h-56 object-cover hover:scale-105 transition-transform duration-500" />
          </div>
          <div className="rounded-xl overflow-hidden">
            <img src="/images/sections/9e03099d5600fe9ad2bbab710e10c6ee.jpg" alt="Ação amigo pescador" className="w-full h-40 sm:h-56 object-cover hover:scale-105 transition-transform duration-500" />
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 w-full">
        <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" preserveAspectRatio="none">
          <path d="M0,40 C360,80 720,0 1080,40 C1260,60 1380,50 1440,40 L1440,80 L0,80 Z" fill="#ffffff" />
        </svg>
      </div>
    </section>
  );
}
